import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("gi_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("gi_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("gi_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const registerClient = async (payload) => {
    const { data } = await api.post("/auth/register-client", payload);
    localStorage.setItem("gi_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const applySession = ({ token, user: u }) => {
    localStorage.setItem("gi_token", token);
    setUser(u);
    return u;
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("gi_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, registerClient, applySession, refreshUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
